<div id="login-page" class="primary-background">
  <div id="login-form" style="min-height: 548px">
    <p-card>
      <div >
        <h1 class="app-heading app-heading-1">
          {{ 'reset_password' | translation }}
        </h1>
        <div *ngIf="policies != null && passwordForm; else loading">
          <div>
            <p>{{ 'requirements' | translation }}:</p>
            <ul style="padding-left: 15px;">
              <li
                *ngIf="policies?.MinimumLength > 0"
                [ngClass]="{
                  'strike-through':
                    passwordForm.get('newPw').dirty &&
                    (!passwordForm.get('newPw').errors ||
                      !passwordForm.get('newPw').errors.minlength),
                }">
                {{ 'requirement_minimum_length' | translation }}:
                {{ policies.MinimumLength }}
              </li>
              <li
                *ngIf="policies?.RequireUppercase"
                [ngClass]="{
                  'strike-through':
                    passwordForm.get('newPw').dirty &&
                    (!passwordForm.get('newPw').errors ||
                      !passwordForm.get('newPw').errors.mustHaveUpercase),
                }">
                {{ 'requirement_uppercase' | translation }}
              </li>
              <li
                *ngIf="policies?.RequireLowercase"
                [ngClass]="{
                  'strike-through':
                    passwordForm.get('newPw').dirty &&
                    (!passwordForm.get('newPw').errors ||
                      !passwordForm.get('newPw').errors.mustHaveLowercase),
                }">
                {{ 'requirement_lowercase' | translation }}
              </li>
              <li
                *ngIf="policies?.RequireNumbers"
                [ngClass]="{
                  'strike-through':
                    passwordForm.get('newPw').dirty &&
                    (!passwordForm.get('newPw').errors ||
                      !passwordForm.get('newPw').errors.mustHaveNumber),
                }">
                {{ 'requirement_number' | translation }}
              </li>
              <li
                *ngIf="policies?.RequireSymbols"
                [ngClass]="{
                  'strike-through':
                    passwordForm.get('newPw').dirty &&
                    (!passwordForm.get('newPw').errors ||
                      !passwordForm.get('newPw').errors
                        .mustHaveSpecialCharacter),
                }">
                {{ 'requirement_special_character' | translation }}
              </li>
            </ul>
          </div>
          <div style="min-height: 270px">
            <app-input
              [control]="passwordForm.get('oldPw')"
              [label]="'password_old' | translation"
              [placeholder]="'password_old' | translation"
              [hideInput]="true">
            </app-input>

            <app-input
              [control]="passwordForm.get('newPw')"
              [label]="'password_new' | translation"
              [placeholder]="'password_new' | translation"
              [hideInput]="true">
            </app-input>

            <app-input
              [control]="passwordForm.get('confirmPw')"
              [label]="'password_confirm' | translation"
              [placeholder]="'password_confirm' | translation"
              [hideInput]="true">
            </app-input>
          </div>
          <password-strength-meter
            (strengthChange)="passwordStrength = $event"
            [minPasswordLength]="policies?.MinimumLength || 3"
            [enableFeedback]="true"
            [password]="
              passwordForm.get('newPw').value
            "></password-strength-meter>

          <div class="flex-list" style="margin-top: 40px">
            <app-button status="secondary" (click)="location.back()">
              {{ 'cancel' | translation }}
            </app-button>
            <app-button
              [isProcessing]="isProcessing"
              status="primary"
              (click)="resetPw()"
              [disabled]="passwordForm.invalid">
              {{ 'reset' | translation }}
            </app-button>
          </div>
        </div>
        <ng-template #loading>
          <div class="reset-password-loading-container">
            <app-loading-dots size="5px"></app-loading-dots>
          </div>
        </ng-template>
      </div>
    </p-card>
  </div>
</div>
